import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const goOrther = () => {
	var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
	if (is_mobi) {
    
	} else {
		// 如果是pc端就跳转
        let params = new URL(window.location.href).pathname.slice(2)
		let baseurl = 'https://www.gnanoai.com' + params
		//  利用方法跳转到对应的页面
		window.location.href = baseurl
	}
}
goOrther()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})